import React from 'react';
import './WarningWrapper.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isShowingWarning: boolean;
  displayName?: string;
  formattedName?: string;
  style?: string;
  warningElement?: any;
}
const WarningWrapper: React.SFC<IProps> = ({
  isShowingWarning,
  displayName,
  formattedName,
  style = '',
  warningElement,
  children,
}) => {
  if (warningElement) {
    return (
      <div className={ `warning-wrapper ${ isShowingWarning ? 'show ' : '' }${ style }` }>
        { isShowingWarning && <span className='warning-message'>{ warningElement }</span> }
        { children }
      </div>
    );
  }

  if (displayName || formattedName) {
    return (
      <div className={ `warning-wrapper ${ isShowingWarning ? 'show ' : '' }${ style }` }>
        { isShowingWarning && <FormattedText style='warning-message' { ... { displayName, formattedName } } /> }
        { children }
      </div>
    );
  }

  return null;
};

export default WarningWrapper;


// WEBPACK FOOTER //
// ./src/components/Shared/WarningWrapper/WarningWrapper.tsx